import React, { useEffect } from "react";
import { Box } from "theme-ui";
import Header from "components/ui/Header";
import Page from "components/ui/Page";

import CalendarView from "containers/Dashboard/components/CalendarView";

/**
 * The full calendar, moved off the dashboard.
 *
 * Spec 3.4 is explicit: the dashboard carries a seven-day rail and
 * LINKS to the full calendar, not a month grid. A month grid on the
 * dashboard asks the operator to scan thirty cells for the two that
 * matter this week, and it pushed everything below it off the screen.
 *
 * Same component, same data, its own page. The rail's "Full calendar"
 * button lands here.
 */
const Calendar: React.FC = () => {
  useEffect(() => {
    document.title = `${process.env.REACT_APP_NAME} | Calendar`;
  }, []);

  return (
    <>
      <Header />
      <Page
        title="Calendar"
        subtitle="Scheduled work by month. The dashboard shows the next seven days."
      >
        <Box>
          <CalendarView role="manager" />
        </Box>
      </Page>
    </>
  );
};

export default Calendar;
